import { CollapsableMenuProps } from '../components/CollapsableMenu'
import { PATH_SELECTOR_ICONS } from './icons'
import { SHARED_OPTIONS_DESCRIPTIONS, SIDE_PANEL_MY_ORDERS } from './shared'

const OPTIONS_LIST = {
  profile: [
    {
      title: 'Dados pessoais',
      to: '/AreaAssociados/MinhaConta?pagina=perfil-dados-pessoais',
      enabled: true
    },
    {
      title: 'Alterar senha',
      to: '/AreaAssociados/MinhaConta?pagina=perfil-alterar-senha',
      enabled: true
    },
    {
      title: 'Documentos',
      to: '/AreaAssociados/MinhaConta?pagina=perfil-documentos',
      enabled: true
    },
    {
      title: 'Endereços',
      to: '/AreaAssociados/MinhaConta?pagina=perfil-enderecos',
      enabled: true
    }
  ]
}

export const PATIENT_SIDE_PANEL: CollapsableMenuProps[] = [
  {
    title: {
      label: 'Início',
      to: '/AreaAssociados/MinhaConta?pagina=inicio',
      icon: PATH_SELECTOR_ICONS.home,
      enabled: true
    }
  },
  {
    title: {
      label: 'Meu perfil',
      subItemsId: 'perfil',
      icon: PATH_SELECTOR_ICONS.profile,
      enabled: true
    },
    subItems: OPTIONS_LIST.profile
  },
  // {
  //   title: {
  //     label: 'Endereços',
  //     subItemsId: 'enderecos',
  //     icon: PATH_SELECTOR_ICONS.address,
  //     enabled: true
  //   },
  //   subItems: OPTIONS_LIST.addresses
  // },
  {
    title: {
      label: 'Carrinho',
      to: '/AreaAssociados/MinhaConta?pagina=carrinho',
      icon: PATH_SELECTOR_ICONS.cart,
      enabled: true
    }
  },
  {
    title: {
      label: 'Minhas consultas',
      to: '/AreaAssociados/MinhaConta?pagina=consultas',
      icon: PATH_SELECTOR_ICONS.consult,
      enabled: true
    }
  },
  SIDE_PANEL_MY_ORDERS
]

export const PATIENT_LINKS_DESCRIPTIONS = {
  'Meu perfil': 'Altere ou consulte seus dados de acesso, dados pessoais, documentos e receitas',
  Endereços: 'Altere endereços cadastrados para entrega de pedidos e cobrança de faturas',

  ...SHARED_OPTIONS_DESCRIPTIONS
}
